import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

/** Download booking confirmation PDF (customer endpoint) */
export const useDownloadMyBookingConfirmationPdfMutation = () =>
  useMutation({
    mutationFn: async (bookingId: string): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(
        `/me/bookings/${bookingId}/confirmation-pdf`,
        { responseType: 'blob' }
      )
      return response.data
    },
  })
